<template>
   <el-tabs type="border-card" style="height:auto">
    <el-tab-pane label="线下退款审核列表" style="height:auto" >
      <el-form :inline="true" :model="order" class="demo-form-inline">
        <el-form-item label="订单编号">
          <el-input v-model.trim="order.orderNo" placeholder="订单编号"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" size="mini" @click="onSubmit">查询</el-button>
        </el-form-item>
      </el-form>
      <el-table
        :data="data"
        height="695"
        size = "small"
        border>
        <el-table-column 
          fixed
          type="expand" Scoped slot>
          <template slot-scope="props">
            <el-tabs v-model="activeName" style="width:100%">
              <el-tab-pane label="交易记录" name="first">
                <el-table
                  :data="props.row.payRecordList"
                  style="height:100%;"
                  border>
                  <el-table-column
                    fixed
                    prop="supplementNo"
                    label="支付编号"
                    width="220"
                    >
                  </el-table-column>
                  <el-table-column
                    prop="outPayNo"
                    label="第三方支付编号"
                    width="260"
                    >
                  </el-table-column>
                  <el-table-column
                    prop="payType"
                    :formatter="formatPayType"
                    show-overflow-tooltip
                    label="支付类型"
                    width="80"
                    >
                  </el-table-column>
                  <el-table-column
                    label="状态"
                    width="100">
                    <template slot-scope="scope">
                      <span v-if="scope.row.payStatus == 1" style="color:#F56C6C">待处理</span>
                      <span v-if="scope.row.payStatus == 2" style="color:#67C23A">付款成功</span>
                      <span v-if="scope.row.payStatus == 3" style="color:#E6A23C">付款失败</span>
                      <span v-if="scope.row.payStatus == 4" style="color:#67C23A">部分付款</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="payMethod"
                    :formatter="formatPay"
                    label="付款方式"
                    width="100"
                    >
                  </el-table-column>
                  <el-table-column
                    prop="payAmount"
                    label="预付金额"
                    width="100">
                  </el-table-column>
                  <el-table-column
                    prop="realAmount"
                    label="已付金额"
                    width="100"
                    >
                  </el-table-column>
                  <el-table-column
                    show-overflow-tooltip
                    prop="payTime"
                    label="付款时间"
                    width="200"
                    >
                  </el-table-column>
                  <el-table-column
                    prop="reason"
                    show-overflow-tooltip
                    label="备注"
                    >
                  </el-table-column>
                  <el-table-column
                    label="操作" >
                    <template slot-scope="scope">
                      <el-button
                      v-if="(scope.row.payType == 3 || scope.row.payType == 4) && scope.row.payStatus == 1 && scope.row.payAmount > 0"
                        size="mini"
                         type="danger"
                        @click="setRefundOrder(scope.row)">退款审核</el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </el-tab-pane>
            </el-tabs>
          </template>
        </el-table-column>
        <el-table-column
          fixed
          prop="orderNo"
          label="订单编号"
          show-overflow-tooltip
          width="220">
        </el-table-column>
        <el-table-column
          fixed
          prop="userName"
          label="用户名"
          show-overflow-tooltip
          width="110">
        </el-table-column>
        <el-table-column
          fixed
          prop="linkUser"
          label="联系人"
          show-overflow-tooltip
          width="110">
        </el-table-column>
        <el-table-column
          fixed
          prop="originalAmount"
          label="商品总金额"
          width="100">
        </el-table-column>
        <el-table-column
          fixed
          prop="discountedAmount"
          label="实际总金额"
          width="100">
        </el-table-column>
        <el-table-column
          prop="transportAmount"
          label="运费金额"
          width="80">
        </el-table-column>
        <el-table-column
          prop="attachAmount"
          label="附加费"
          width="100">
        </el-table-column>
        <el-table-column
          prop="rebateAmount"
          label="已退金额"
          width="100">
        </el-table-column>
        <el-table-column
          prop="couponAmount"
          label="优惠劵"
          width="80">
        </el-table-column>
        <el-table-column
          prop="preferentialMargins"
          label="总优惠"
          width="80">
        </el-table-column>
        <el-table-column
          prop="originalAmount"
          label="原总金额"
          width="100">
        </el-table-column>
        <el-table-column
          prop="totalAmount"
          label="总金额"
          width="100">
        </el-table-column>
        <el-table-column
          label="退款金额"
          width="100">
          <template slot-scope="scope">
            <span style="color:#F56C6C">{{scope.row.payAmount - scope.row.totalAmount}}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="状态"
          width="80"
          >
          <template slot-scope="scope">
            <span v-if="scope.row.orderStatus == -2" style="color:#F56C6C">退款申请</span>
            <span v-if="scope.row.orderStatus > 2 && scope.row.isRebating == 1" style="color:#E6A23C">退款处理</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="createDate"
          show-overflow-tooltip
          label="下单时间"
          width="160">
        </el-table-column>
        <el-table-column
          prop="remark"
          width="180"
          label="备注"
          show-overflow-tooltip>
        </el-table-column>
      </el-table>
      <pagination :pagination="pagination" v-on:paginationClick="queryPagination"></pagination>
    </el-tab-pane>
   </el-tabs>
</template>
<script>
import pagination from "../../../common/util/pagination";

export default {
  data() {
    return {
      data: [],
      optionItem: {},
      formLabelWidth: '140px',
      dialogFormVisible:false,
      discountedPrice: 0 , // 原价
      title: '编辑子订单信息',
      editorMehotd: 1,
      dialogOrderFormVisible: false,
      activeName: 'first',
      addressList: [],
      payList:[],
      order: {
        payType: '',
        orderNo: '',
        orderStatus: 8,
        token: this.user.getToken()
      },
      invoiceParam: {
      },
      pagination: {
        pageSize: 10,
        pageNum: 1,
        pageTotal: 0
      },
      orderNos: '',
      options: [{
          value: 1,
          label: '普通发票'
        }, {
          value: 2,
          label: '专用发票'
        }, {
          value: 3,
          label: '个人'
        }]
    };
  },
  components: {
    pagination
  },
  methods: {
    fun(){
        return Number(val).toFixed(2);
    },
    setRefundOrder:function(row) {
      // 判断该订单下是否存在需要发货的字订单
      this.$confirm('确定要处理该笔退款记录吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
            this.http.post(
            '/offline/order/refund/audit', 
            {
              mainOrderNo: row.mainOrderNo,
              supplementNo: row.supplementNo,
              subOrderNo: row.subOrderNo,
              token: this.user.getToken()
            }, res => {
              if (res.success) {
                // 返回正确的处理
                this.getOrderData();
              } else {
                // 返回错误的处理
                this.$message.error(res.message)
              }
            })
          }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消该笔退款'
        });          
      });;
    },
    handleSelectionChange: function(rows) {
      this.orderNos = ''
      rows.forEach((item) => {
        this.orderNos += item.orderNo + ','
      })
    },
    tableRowClassName({row, rowIndex}) {
      if (row.orderStatus === 3) {
        return 'warning-row';
      } else if (row.orderStatus === 2) {
        return 'success-row';
      } else if (row.orderStatus === 8) {
        return 'success-refund';
      } else if (row.orderStatus === 1) {
        return 'success-paid';
      } else if (row.orderStatus === 4) {
        return 'success-over';
      }
      return '';
    },
    formatPay: function(row, column, cellValue) {
      if (cellValue === 1) {
        return "微信";
      } else if (cellValue === 2) {
        return "支付宝";
      } else if (cellValue === 3) {
        return "对公付款";
      }
    },
    formatPayType: function(row, column, cellValue) {
      if (cellValue === 1) {
        return "付款";
      } else if (cellValue === 2) {
        return "附加费";
      } else if (cellValue === 3) {
        return "优惠退还";
      } else if (cellValue === 4) {
        return "取消";
      }
    },
    formatPayStatus: function(row, column, cellValue) {
      if (cellValue === 1) {
        return "未付款";
      } else if (cellValue === 2) {
        return "已付款";
      } else if (cellValue === 3) {
        return "失败";
      } else if (cellValue === 4) {
        return "部分付款";
      }
    },
    formatInvoice: function(row, column, cellValue) {
      if (cellValue === 1) {
        return "未开票";
      } else if (cellValue === 2) {
        return "已开票";
      } else if (cellValue === 3) {
        return "不需要";
      }
    },
    formatAddress: function(row, column, cellValue) {
      if(cellValue) {
        return cellValue.province + ' ' + cellValue.city + ' ' + cellValue.area + ' ' + cellValue.addressDetail;
      }
    },
    formatStatus: function(row, column, cellValue) {
      if (cellValue === 2) {
        return "待审核";
      }else if (cellValue === 1) {
        return "待付款";
      }else if (cellValue === 3) {
        return "待发货";
      }else if (cellValue === 4) {
        return "已发货";
      }
    },
    formatMobile: function(row, column, cellValue) {
      if (cellValue) {
        return cellValue.mobile;
      }
    },
    getOrderData: function() {
      this.optionItem = this.common.extend(this.order, this.pagination);
      // 初始化默认加载菜单
      this.http.post(
        '/offline/order/refund/apply/list',
        this.optionItem,
        res => {
          if (res.success) {
            // 返回正确的处理
            this.data = res.datas.data;
            this.pagination.pageSize = res.datas.page.pageSize
            this.pagination.pageNum = res.datas.page.pageNum
            this.pagination.pageTotal = res.datas.page.pageCount
          } else {
            // 返回错误的处理
            this.$message.error(res.message)
          }
        }
      );
    },
    onSubmit: function() {
      this.pagination.pageNum = 1
      this.getOrderData()
    },
    queryPagination: function(currPage) {
      this.pagination.pageNum = currPage
      this.getOrderData()
    },
    remarkSubTo: function(row) {
      // 判断该订单下是否存在需要发货的字订单
      this.$prompt('请输入子订单备注信息', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
        }).then(({ value }) => {
          console.log("value:" + value)
          this.http.post(
            '/offline/order/detail/remark/subset', 
            {
              orderNo: row.orderNo,
              remark: value,
              token: this.user.getToken()
            }, res => {
              if (res.success) {
                // 返回正确的处理
                this.getOrderData();
              } else {
                // 返回错误的处理
                this.$message.error(res.message)
              }
          });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '取消输入'
          });       
      });
    },
    remarkTo: function(row) {
      // 判断该订单下是否存在需要发货的字订单
      this.$prompt('请输入主订单备注信息', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
        }).then(({ value }) => {
          this.http.post(
            '/offline/order/remark/set',
            {
              orderNo: row.orderNo,
              remark: value,
              token: this.user.getToken()
            }, res => {
              if (res.success) {
                // 返回正确的处理
                this.getOrderData();
              } else {
                // 返回错误的处理
                this.$message.error(res.message)
              }
          });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '取消输入'
          });       
      });
    },
  },
  mounted: function() {
    this.getOrderData();
  },
};
</script>


<style>
.invoice-css {
  padding: 10px 0 20px 0; width: 60%; text-align:center;
}
.el-table th {
  background: #F5F7FA;
}
.el-table__expanded-cell {  
  padding: 0px 0px 15px 47px !important;
}
.el-tabs {
  border:1px solid #eee;
}
.el-tabs__nav {
  padding: 0 20px;
}
.el-tabs__active-bar {
  margin-left: 20px;
}
.el-input--suffix .el-input__inner {
  padding-right: 16px;
}

.demo-table-expand {
  font-size: 0;
}
.el-form-item__content {
  line-height: none;
}
.el-table .warning-row {
  background: oldlace;
}

.el-table .success-row {
  background: #f0f9eb;
}
.el-table .success-refund{
  background: #FFF;
}
.el-table .success-paid{
  background:#FFF;
}

.el-table .success-over {
  background: #f5f7fa;
}
.el-table .cell {
  line-height: 24px !important;
}
</style>


// WEBPACK FOOTER //
// src/components/views/refund/offline/userOrderRefundAudit.vue